module.exports = __webpack_public_path__ + "static/media/veritas-screenshot-2.2a80b386.png";